// Angular
import { ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// External
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import * as moment from "moment";
import { ApiService } from "./../../services/api";
import { PostTypes } from "./../../models/post-types";
import { Post } from "./../../models/post";
import { Tournament } from "./../../models/tournament";
import { FacilityTypes } from "./../../models/facility-types";
import { ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";

import { MapsAPILoader } from "@agm/core";
import { OAuthService } from "app/services/o-auth";
import { ElasticService } from "app/services/elastic";
@Component({
  templateUrl: "./club.detail.component.html",
})
export class ClubDetailComponent implements OnInit {
  public disabled: boolean;
  public avatarLoading: boolean;
  public form: FormGroup;
  public clubForm: FormGroup;
  public changeEmail: FormGroup;
  public commission: number = 10;
  imageLoader1 = false;
  public notification: Array<{
    id: string;
    count: number;
    name: string;
    image: string;
  }>;
  public followers: Array<any>;
  public posts: Array<Post>;
  public imageLoader: boolean = true;
  public coverLoading: boolean;
  public scorecardCount = 0;
  public loggedInuser: any;
  public userId: string;
  public club: any;
  public list: Array<any>;
  public offerList: Array<any>;
  public courses: Array<any>;
  public tournaments: Array<Tournament>;
  public scorecards: Array<any>;
  public isEmailModal = false;
  public isCommisionModal = false;
  public inviteTournament: string;
  public facilityList: Array<any>;
  public members: Array<any>;
  public payments: Array<any>;
  public daysLeft: number;
  public followerCount = 0;
  public postCount = 0;
  public VoucherCount = 0;
  public isEmailError = false;
  public orderCount = 0;
  public pendingAmount = 0;
  public orderAmount = 0;
  public amountPaid = 0;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public address: string;
  public isStripe: boolean;
  public tournamentCount = 0;
  public isEmailExist = false;
  public users: Array<any> = [];
  public query: string = "";
  public user: any = {};
  public clubDetails: any;
  private typingDelay: any;
  showPostActionButtons: boolean;
  showFollowersActionButtons: boolean;
  insightFollower: any;
  stats: any = {};
  @ViewChild("search")
  public searchElementRef: ElementRef;
  constructor(
    private route: ActivatedRoute,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private mapsAPILoader: MapsAPILoader,
    private fireAuth: AngularFireAuth,
    private ngZone: NgZone,
    private oAuthService: OAuthService,
    private elasticService: ElasticService,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.offerList = [];

    this.disabled = false;
    this.avatarLoading = false;
    this.coverLoading = false;
    this.notification = [];
    this.form = new FormGroup({
      name: new FormControl("", Validators.required),
      db_phone: new FormControl("", Validators.pattern("[0-9 ]+")),
      info: new FormControl("", Validators.required),
      address: new FormControl(""),
      contactPersonName: new FormControl(""),
      contactPersonEmailId: new FormControl(""),
      postCode: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
      commission: new FormControl(10, Validators.required),
    });
    this.changeEmail = new FormGroup({
      email: new FormControl("", Validators.required),
    });
    //   lodash.forEach(PostTypes, (item, key) => {
    // this.notification.push({id:key,name:item[0],count:5,image:item[1]})
    //   })
  }
  openUpdateDetailModal(event) {
    $("#addMemberModal").modal("hide");
    $("#myModal23").modal("show");
  }
  
  ngOnInit() {
    this.userId = this.route.snapshot.params["id"];
    this.loggedInuser = this.oAuthService.getClub();

    this.showPostActionButtons = this.loggedInuser.type == 3 ? true : false;
    this.showFollowersActionButtons =
      this.loggedInuser.type == 3 ? true : false;

    if (!this.userId) {
      return;
    }

    // this.getFollower();
    // this.getPosts();
    // this.getTournaments();
    // this.getClubMembers();
    // this.getClubSubscription();
    // this.getOfferCount();
    // this.getScorecards()
    this.fireDatabase.object(`/users/${this.userId}`).subscribe(
      (result) => {
        this.club = result;

        if (this.club.bank != undefined && this.club.bank.stripe_user_id) {
          this.isStripe = true;
        } else {
          this.isStripe = false;
        }
        this.changeEmail = new FormGroup({
          email: new FormControl(this.club.email, Validators.required),
        });
        if (!this.club.address) {
          this.club.address = "";
        }
        this.address = this.club.address ? this.club.address : "";
        this.imageLoader = false;
        this.form = new FormGroup({
          name: new FormControl(this.club.name, Validators.required),
          db_phone: new FormControl(
            this.club.db_phone,
            Validators.pattern("[0-9 ]+")
          ),
          info: new FormControl(this.club.info, Validators.required),
          address: new FormControl(this.club.address, Validators.required),
          contactPersonName: new FormControl(
            this.club.contactPersonName,
            Validators.required
          ),
          contactPersonEmailId: new FormControl(
            this.club.contactPersonEmailId,
            Validators.required
          ),
          postCode: new FormControl(this.club.postCode, Validators.required),
          city: new FormControl(this.club.city, Validators.required),
          commission: new FormControl(
            this.club.commission,
            Validators.required
          ),
        });

        if (this.club.isVerified) {
          this.getFacility();
        }
        if (this.club.courses) {
          this.courses = [];

          lodash.forEach(this.club.courses, (item: any, key) => {
            const course = {
              name: item.name,
              holes: item.holes,
              tees: [],
              $key: key,
            };

            lodash.forEach(item.tees, (tee: any) => {
              course.tees.push({
                name: tee.name,
                color: tee.color,
              });
            });

            this.courses.push(course);
          });
          const now = new Date();
          if (result["subscription"]) {
            if (result["subscription"] * 1000 > now.getTime()) {
              this.daysLeft = Math.round(
                Math.abs(
                  (result["subscription"] * 1000 - now.getTime()) /
                    (24 * 60 * 60 * 1000)
                )
              );
            } else {
              this.daysLeft = -1;
            }
          } else {
            if (result["trial"]) {
              if (result["trial"] * 1000 > now.getTime()) {
                this.daysLeft = Math.round(
                  Math.abs(
                    (result["trial"] * 1000 - now.getTime()) /
                      (24 * 60 * 60 * 1000)
                  )
                );
              } else {
                this.daysLeft = -3;
              }
            } else {
              this.daysLeft = -2;
            }
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
    this.zoom = 4;
    this.latitude = 39.8282;
    this.longitude = -98.5795;

    this.setCurrentPosition();

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"],
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.club.address = place.formatted_address;
          const results = place.address_components;
          this.form.patchValue({ address: this.club.address });

          this.club.city = this.findResult(
            results,
            "administrative_area_level_2"
          );
          this.form.controls["city"].patchValue(this.club.city);
          this.club.state = this.findResult(
            results,
            "administrative_area_level_1"
          );
          this.club.country = this.findResult(results, "country");
          this.club.postCode = this.findResult(results, "postal_code");
          this.form.controls["postCode"].patchValue(this.club.postCode);

          this.club.location.lat = place.geometry.location.lat();
          this.club.location.lon = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
    this.form.get("address").valueChanges.subscribe((val) => {});

    this.clubDetails = this.oAuthService.getClub();

    this.clubForm = new FormGroup({
      fullName: new FormControl("", Validators.required),
      role: new FormControl(this.clubDetails.role),
      email: new FormControl("", Validators.email),
      username: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      password: new FormControl("", [
        Validators.required,
        Validators.minLength(6),
      ]),
      confirm: new FormControl("", Validators.required),
    });

    this.clubForm.controls["username"].valueChanges.subscribe((value) => {
      this.username(value);
    });

    this.clubForm.controls["password"].valueChanges.subscribe(() => {
      this.confirm();
    });

    this.clubForm.controls["confirm"].valueChanges.subscribe(() => {
      this.confirm();
    });
    this.clubForm.controls["email"].valueChanges.subscribe((value) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(value).toLowerCase())) {
        this.checkEmail(value);
      }
    });
  }

  onTabChanged(event) {
    switch (event.index) {
      case 10:
        if (!(this.members && this.members.length > 0)) {
          this.getClubMembers();
        }
      case 8:
        if (!(this.tournaments && this.tournaments.length > 0)) {
          this.getTournaments();
        }
        break;
      case 9:
        if (!(this.scorecards && this.scorecards.length > 0)) {
          this.getScorecards();
        }
        break;
      case 7:
        this.imageLoader1 = true;
        Promise.all([this.getPosts()]).then(() => {
          this.imageLoader1 = false;
        });
        break;
      case 6:
        this.imageLoader1 = true;
        Promise.all([this.getFollower()]).then(() => {
          this.imageLoader1 = false;
        });
        break;
      case 4:
        this.imageLoader1 = true;
        Promise.all([this.getFollower()]).then(() => {
          this.imageLoader1 = false;
        });
        break;
      case 5:
        this.imageLoader1 = true;
        Promise.all([this.getOfferCount()]).then(() => {
          this.imageLoader1 = false;
        });
        break;
      case 11:
        this.getClubSubscription();
        break;
      case 1:
        this.imageLoader1 = true;
        Promise.all([this.getStats()]).then(() => {
          this.imageLoader1 = false;
        });
    }
  }

  async getStats() {
    this.fireDatabase
      .object(`/statistics/${this.userId}`)
      .subscribe((result) => {
        this.stats = result;
      });
  }

  public findResult = function (results, name) {
    const result = lodash.find(results, function (obj) {
      return obj.types[0] === name;
    });
    return result ? result.long_name : null;
  };

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }

  imageLoaderClubMembers = false;
  async getClubMembers() {
    this.imageLoaderClubMembers = true;
    this.members = [];
    this.fireDatabase
      .object(`/club-members/${this.userId}`)
      .subscribe(async(result) => {
        if (result) {
          for (let i = 0; i < Object.keys(result).length; i++) {
          let key = Object.keys(result)[i];
          let user = await this.apiService.object(`/users/${key}`);
            let profile = await this.apiService.object(
              "user-profiles/" + key + "/" + this.userId
            );
            user.status = profile.status ? profile.status : 1;
            user.isVerified = profile.isVerified ? profile.isVerified : true;
            user.role = profile.role ? profile.role : true;
            this.members.push(user);
        }
          this.imageLoaderClubMembers = false;
        } else {
          this.imageLoaderClubMembers = false;
        }
      });
  }

  imageLoaderClubSubscription = false;
  getClubSubscription() {
    this.imageLoaderClubSubscription = true;
    this.apiService
      .list(`/club-subscriptions/${this.userId}`)
      .then((pay: Array<any>) => {
        this.payments = pay;
        this.imageLoaderClubSubscription = false;
      });
  }
  createNotification() {
    this.notification = [];

    lodash.forEach(PostTypes, (item, key) => {
      this.notification.push({
        id: key,
        name: item[0],
        count: 0,
        image: item[1],
      });
    });
    this.changeDetector.detectChanges();
  }
  increaseNotification() {
    lodash.forEach(this.notification, (item, key) => {
      item.count++;
    });
  }
  getFacility() {
    this.facilityList = [];
    lodash.forEach(FacilityTypes, (item, key) => {
      this.facilityList.push({ id: key, name: item, isAvailable: false });
    });
    const fa = [];

    lodash.forEach(this.club.facility, (item, key) => {
      for (var i = 0; i < this.facilityList.length; i++) {
        if (key == this.facilityList[i].id) {
          this.facilityList[i].isAvailable = true;
        }
      }
    });
  }
  public facilitySelect(event, facility) {
    if (event) {
      this.apiService
        .set(`/users/${this.userId}/facility/${facility.id}`, facility.name)
        .then(() => {
          // this.getClubInsight();
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      this.apiService
        .set(`/users/${this.userId}/facility/${facility.id}`, null)
        .then(() => {
          // this.getClubInsight();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  getFollower() {
    this.fireDatabase
      .object(`/user-followers/${this.userId}`)
      .subscribe((result) => {
        this.createNotification();
        if (result && result.count > 0) {
          this.followers = [];
          this.followerCount = result.count;
          lodash.forEach(result.followers, (item, key) => {
            if (item) {
              this.fireDatabase
                .object(`/user-push-settings/${key}`)
                .subscribe((result) => {
                  this.increaseNotification();
                  lodash.forEach(result, (item1, key1) => {
                    if (key1 == this.userId) {
                      if (item1) {
                        lodash.forEach(item1, (item2, key2) => {
                          for (var i = 0; i < this.notification.length; i++) {
                            if (key2 == this.notification[i].id && item2) {
                              this.notification[i].count--;
                            }
                          }
                        });
                      }
                    }
                  });
                    this.changeDetector.detectChanges();
                });
            }
          });
          lodash.forEach(result.followers, (item, key) => {
            if (item) {
              this.fireDatabase.object(`/users/${key}`).subscribe(
                (result1) => {
                  if (result1) {
                    this.followers.push(result1);
                  }
                },
                (error) => {
                  alert(error);
                }
              );
            }
          });
        }
          this.changeDetector.detectChanges();
      });
  }

  getFollowersList(id) {
    this.insightFollower = [];
    var followUid = [];
    this.fireDatabase
      .object(`/user-followers/${this.userId}`)
      .subscribe((result) => {
        lodash.forEach(result.followers, (item, key) => {
          if (item) {
            followUid.push(key);
            this.fireDatabase
              .object(`/user-push-settings/${key}`)
              .subscribe((result) => {
                if (result) {
                  lodash.forEach(result, (item1, key1) => {
                    if (key1 == this.club.cid) {
                      if (item1) {
                        lodash.forEach(item1, (item2, key2) => {
                          if (id == key2 && item2) {
                            var i = followUid.indexOf(key);
                            if (i != -1) {
                              followUid.splice(i, 1);
                            }
                          } else {
                          }
                        });
                      }
                    }
                  });
                }
              });
          }
        });
      });
    lodash.forEach(followUid, (item, key) => {
      this.fireDatabase.object(`/users/${item}`).subscribe((user: any) => {
        this.insightFollower.push(user);
      });
    });
    $("#followersListModal").modal("show");
  }
  getOfferCount() {
    this.orderAmount = 0;
    this.fireDatabase
      .object(`/user-offers/${this.userId}`)
      .subscribe((result) => {
        if (result) {
          lodash.forEach(result, (item, key) => {
            if (item) {
              item.$key = key;
              this.offerList.push(item);
              ++this.VoucherCount;
              
            }
          });
          this.offerList.sort((a, b) => {
            return a.status - b.status
          });
        }
      });
  }

  getPosts() {
    let cid = this.userId;
    this.fireDatabase.list(`/users-posts/${cid}`).subscribe(
      (result: Array<any>) => {
        this.list = [];
        let count = 0;
        lodash.forEach(result, (item) => {
          if (item.text) {
            var date = new Date(item.date * 1000);
            var o =
              date.getFullYear() +
              "-" +
              ("0" + (date.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + date.getDate()).slice(-2);
            item.date = o;
            if (this.club.uid == item.userId) {
              this.list.push(item);
              count++;
              if (count === 1) {
                this.postDetail(item);
              }
            }
          }
        });
        this.imageLoader = false;
      },
      (error) => {
        console.error(error);
        this.imageLoader = false;
      }
    );
  }

  public shared: Post;
  public mentioned: Array<any>;
  public commentList: Array<any>;
  public likeList: Array<{ author: string; authorImage: string; key: string }>;
  public shareLikes: Array<{
    author: string;
    authorImage: string;
    key: string;
  }>;
  public shareComments: Array<any>;
  public postData: any;
  public attachmentExt: string;
  public text: string;
  public likeCount: number;
  public commentCount: number;
  public mentionCount: number;
  postDetail(post: Post) {
    this.commentList = [];
    this.likeList = [];
    this.shareLikes = [];
    this.shareComments = [];
    this.postData = post;
    if (post.photo) {
      this.attachmentExt = post.photo.url;
    }
    this.text = this.postData.text;
    this.fireDatabase.object(`/users/${post.author}`).subscribe((user: any) => {
      this.postData.authorName = user.username;
      this.postData.authorImage = user.avatar_thumb;
    });
    if (this.postData.mentioned) {
      this.mentioned = [];
      this.mentionCount = 0;
      lodash.forEach(this.postData.mentioned, (mention, key) => {
        this.mentionCount++;
        this.mentioned.push({
          user_name: mention.username,
          user_id: key,
          type: mention.type,
        });
      });
    }
    if (this.postData.shared) {
      this.fireDatabase
        .object(
          `/users-posts/${this.postData.shared.uid}/${this.postData.shared.pid}`
        )
        .subscribe((shared) => {
          this.shared = shared;
          if (shared.$value) {
            this.postData.isShared = true;
            console.log(this.shared);
            this.fireDatabase
              .object(`/users/${shared.author}`)
              .subscribe((user: any) => {
                this.postData.Sharedauthor = user.username;
                this.postData.SharedauthorImage = user.avatar_thumb;
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/likes`)
              .subscribe((likes) => {
                if (likes) {
                  lodash.forEach(likes, (like) => {
                    this.fireDatabase
                      .object(`/users/${like}`)
                      .subscribe((user: any) => {
                        like = user.username;
                        this.shareLikes.push({
                          author: user.username,
                          authorImage: user.avatar_thumb,
                          key: user.$key,
                        });
                      });
                  });
                }
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/comments`)
              .subscribe((comments) => {
                if (comments) {
                  lodash.forEach(comments, (comment) => {
                    if (comment) {
                      this.fireDatabase
                        .object(`/users/${comment.author}`)
                        .subscribe((user: any) => {
                          comment.author = user.username;
                          comment.authorImage = user.avatar_thumb;
                          comment.key = user.$key;
                          this.shareComments.push(comment);
                        });
                    }
                  });
                }
              });
          }
        });
    } else {
      this.postData.isShared = false;
    }
    this.fireDatabase.object(`/posts/${post.$key}/likes`).subscribe((likes) => {
      this.likeCount = 0;
      if (likes) {
        lodash.forEach(likes, (item, like) => {
          this.likeCount++;
          if (item) {
            this.fireDatabase
              .object(`/users/${like}`)
              .subscribe((user: any) => {
                like = user.username;
                this.likeList.push({
                  author: user.username,
                  authorImage: user.avatar_thumb,
                  key: user.$key,
                });
              });
          }
        });
      }
    });
    this.fireDatabase
      .object(`/posts/${post.$key}/comments`)
      .subscribe((comments) => {
        this.commentCount = 0;
        if (comments) {
          lodash.forEach(comments, (comment) => {
            this.commentCount++;
            if (comment) {
              this.fireDatabase
                .object(`/users/${comment.author}`)
                .subscribe((user: any) => {
                  comment.author = user.username;
                  comment.authorImage = user.avatar_thumb;
                  comment.key = user.$key;
                  this.commentList.push(comment);
                  // this.postData.date = moment().unix();
                  lodash.forEach(this.commentList, (item) => {
                    console.log(item);
                    item.date = new Date(item.date * 1000);
                    var dd = item.date.getDate();
                    var mm = item.date.getMonth() + 1;
                    var yyyy = item.date.getFullYear();
                    item.date = dd + "/" + mm + "/" + yyyy;
                    console.log(item.date);
                  });
                });
            }
          });
        }
      });
  }

  imageLoaderTournaments = false;
  getTournaments() {
    this.imageLoaderTournaments = true;
    this.tournaments = [];

    this.apiService
      .list("/tournaments")
      .then((tournaments: Array<Tournament>) => {
        this.tournaments = tournaments.filter((tournament) => {
          return tournament.cid === this.userId;
        });
        lodash.forEach(this.tournaments, (item, key) => {
          const date = new Date(parseFloat(item.startDate) * 1000);

          const o =
            date.getFullYear() +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + date.getDate()).slice(-2);

          item.startDate = o;

          if (item.leaderboard) {
            if (item.teamPlay == 0) {
              lodash.forEach(item.leaderboard, (team, teamKey) => {
                lodash.forEach(team, (player, playerUid) => {
                  if (playerUid !== "team") {
                    ++this.scorecardCount;
                  }
                });
              });
            }
            if (item.teamPlay > 0) {
              lodash.forEach(item.leaderboard, (team, teamKey) => {
                ++this.scorecardCount;
              });
            }
          }
        });
        this.imageLoaderTournaments = false;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  imageLoaderScorecards = false;
  getScorecards() {
    this.imageLoaderScorecards = true;
    this.scorecards = [];
    this.apiService
      .list("/scorecards")
      .then((tournaments: Array<any>) => {
        this.scorecards = tournaments.filter((tournament) => {
          return tournament.cid === this.userId;
        });
        lodash.forEach(this.scorecards, (item) => {
          ++this.scorecardCount;

          const date = new Date(parseFloat(item.date) * 1000);
          const o =
            date.getFullYear() +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + date.getDate()).slice(-2);
          item.startDate = o;
        });
        this.imageLoaderScorecards = false;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  public changeAvatar(event): void {
    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);
    const fileExt = file.name.split(".").pop();
    const fileName = `${this.userId}_${moment().unix()}.${fileExt}`;

    this.avatarLoading = true;
    this.apiService
      .upload("/users/avatars", fileName, file, {
        customMetadata: { uid: this.userId },
      })
      .then((result) => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.avatarLoading = false;
            this.club.avatar = result.downloadURL;
          };
          image.onerror = () => {
            this.avatarLoading = false;
          };
        } else {
          this.avatarLoading = false;
        }
      })
      .catch((error) => {
        console.error(error);

        this.avatarLoading = false;
      });
  }

  public changeBackground(event): void {
    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);
    const fileExt = file.name.split(".").pop();
    const fileName = `${this.userId}_${moment().unix()}.${fileExt}`;

    this.coverLoading = true;
    this.apiService
      .upload("/users/background", fileName, file, {
        customMetadata: { uid: this.userId },
      })
      .then((result) => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.coverLoading = false;
            this.club.background = result.downloadURL;
          };
          image.onerror = () => {
            this.coverLoading = false;
          };
        } else {
          this.coverLoading = false;
        }
      })
      .catch((error) => {
        console.error(error);

        this.coverLoading = false;
      });
  }

  submit() {
    const ob = {
      info: this.form.controls["info"].value,
      db_phone: "" + this.form.controls["db_phone"].value,
      name: this.form.controls["name"].value,
      contactPersonName: this.form.controls["contactPersonName"].value,
      updatedAt: new Date().getTime() / 1000,
      address: this.form.controls["address"].value
        ? this.form.controls["address"].value
        : null,
      state: this.club.state ? this.club.state : null,
      city: this.club.city ? this.club.city : null,
      country: this.club.country ? this.club.country : null,
      postCode: this.form.controls["postCode"].value
        ? this.form.controls["postCode"].value
        : null,
      location: this.club.location ? this.club.location : null,
      contactPersonEmailId: this.form.controls["contactPersonEmailId"].value,
      commission: this.form.controls["commission"].value
        ? this.form.controls["commission"].value
        : 10,
    };
    this.disabled = true;
    this.apiService
      .update(`/users/${this.userId}`, ob)
      .then(() => {
        this.disabled = false;
        $("#myModal23").modal("hide");
      })
      .catch((error) => {
        console.error(error);

        this.disabled = false;
      });
  }

  changeEmailSubmit() {
    this.fireAuth.auth
      .fetchProvidersForEmail(this.changeEmail.controls["email"].value)
      .then((result) => {
        if (result.length) {
          this.isEmailError = true;
        } else {
          this.isEmailError = false;
          this.apiService
            .set(
              `/server-process/change-user-email/${this.club.uid}/${this.userId}`,
              this.changeEmail.controls["email"].value
            )
            .then(() => {
              this.disabled = false;
              this.isEmailError = false;

              this.club.email = this.changeEmail.controls["email"].value;
              $("#changeEmailModal").modal("hide");
              this.toggleEmail();
            })
            .catch((error) => {
              console.error(error);
              this.isEmailError = false;

              this.disabled = false;
            });
        }
      });
  }
  toggleEmail() {
    this.isEmailModal = !this.isEmailModal;
  }
  toggleCommision() {
    this.isCommisionModal = !this.isCommisionModal;
    if (this.isCommisionModal) {
      this.commission = this.club.commission;
    }
  }
  updateCommision() {
    this.club.commission = this.commission;
    this.apiService.set(
      `users/${this.userId}/commission`,
      this.club.commission
    );
    this.toggleCommision();
  }
  showAddMemberModal = false
  openModel() {
    $("#addMemberModal").modal("show");
      this.showAddMemberModal = true
    this.clubForm.reset({
      fullName: null,
      role: this.clubDetails.role,
      email: null,
      username: null,
      phone: null,
      password: null,
      confirm: null,
    });
    this.isEmailExist = false;
  }
  username(value: string) {
    if (!value) {
      const errors = this.clubForm.controls["username"].errors;
      if (errors) {
        delete errors.used;
        this.clubForm.controls["username"].setErrors(errors);
      }
      return;
    }
    this.apiService
      .list("/index/users", {
        query: {
          orderByValue: true,
          equalTo: this.clubForm.controls["username"].value.toLowerCase(),
        },
      })
      .then(
        (result) => {
          if (result.length) {
            this.clubForm.controls["username"].setErrors({ used: true });
          } else {
            const errors = this.clubForm.controls["username"].errors;
            if (errors) {
              delete errors.used;
              this.clubForm.controls["username"].setErrors(errors);
            }
          }
        },
        (error) => {
          alert(error);
        }
      );
  }
  checkEmail(value) {
    this.fireAuth.auth.fetchProvidersForEmail(value).then((result) => {
      if (result.length) {
        this.isEmailExist = true;
        this.clubForm.controls["password"].setErrors(null);
        this.clubForm.controls["confirm"].setErrors(null);
        this.clubForm.controls["username"].setErrors(null);
      } else {
        this.isEmailExist = false;
      }
    });
  }
  confirm() {
    const password = this.clubForm.controls["password"].value;
    const confirm = this.clubForm.controls["confirm"].value;
    if (password !== confirm) {
      this.clubForm.controls["confirm"].setErrors({ confirm: true });
    } else {
      this.clubForm.controls["confirm"].setErrors(null);
    }
  }
  closeModal() {
    this.user = {};
    this.query = "";
    this.showAddMemberModal = false
  }
  changeQuery() {
    clearTimeout(this.typingDelay);
    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }
  chooseUser(user) {
    this.user = user;
  }
  searchMention() {
    const queryParams = {
      index: "users",
      type: "user",
      "body/query/bool/must/query_string/query": `${this.query}*`,
      "body/query/bool/must/query_string/fields": ["fullName^10", "username^2"],
    };
    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        if (result && result["hits"]) {
          lodash.forEach(result["hits"], async (item) => {
            const user = lodash.assign({ $key: item["_id"] }, item["_source"]);
            if (user.$key) {
              user.key = user.$key;
            }
            let firebaseUser = await this.apiService.object(
              `users/${user.key}`
            );
            if (!firebaseUser.deactivated) {
              this.users.push(user);
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  onFocus() {
    this.searchMention();
  }
  onBlur() {
    setTimeout(() => {
      this.users = [];
    }, 500);
  }
  addMemberSubmit() {
    let clubId = this.userId;
    let req = {
      role: +this.user.role,
      type: this.club.type,
      status: 1,
      isVerified: true,
      updatedAt: new Date().getTime() / 1000,
    };
    let memberId = this.user.key;
    if (this.user.$key) {
      memberId = this.user.$key;
    }
    this.apiService
      .set(`/server-process/add-member/${clubId}/${memberId}`, req)
      .then(() => {
        this.closeModal();
        $("#addMemberModal").modal("hide");
      })
      .then(() => location.reload())
      .catch((error) => {
        alert(error);
      });
  }
}
